/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/camelcase */
import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import ExhibitionCard from 'components/ExhibitionCard';
import PageTitle from 'components/PageTitle';
import i18n from 'i18n';
import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ApplicationState from 'store/interfaces';
import styles from './styles';

const useStyles = makeStyles(styles);

interface Props {
  operator_uuid: string;
}

const AdministrationPanel = ({ operator_uuid }: Props) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <React.Fragment>
      <PageTitle title={i18n.t('PANEL_PAGE.ADMINISTRATION_AUTO_SKY_KEY')} />
      <Grid className={classes.content} container spacing={3}>
        <Grid item xs={4}>
          <ExhibitionCard
            contentImg={
              <img
                src={'/images/OnlineDocument-bro.svg'}
                alt={i18n.t('PANEL_PAGE.PUSH_PIN_BUTTON_KEY')}
              />
            }
            footer={[
              {
                name: i18n.t('PANEL_PAGE.AUTO_KEY_DOCUMENTATION'),
                icon: <ArrowRightAltIcon />,
                onClick: () =>
                  window.open(
                    'https://skyinone.atlassian.net/wiki/spaces/AUTODOCPTBR/overview',
                    '_blank',
                    'noopener'
                  ),
              },
            ]}
          />
        </Grid>
        <Grid item xs={4}>
          <ExhibitionCard
            contentImg={
              <img
                src={'/images/UsabilityTesting-bro.svg'}
                alt={i18n.t('PANEL_PAGE.PUSH_PIN_BUTTON_KEY')}
              />
            }
            footer={[
              {
                name: i18n.t('PANEL_PAGE.MY_PROFILE_AUTO_SKY_KRY'),
                icon: <ArrowRightAltIcon />,
                onClick: () => history.push(`/operators/${operator_uuid}/edit`),
              },
            ]}
          />
        </Grid>
        <Grid item xs={4}>
          <ExhibitionCard
            contentImg={
              <img
                src={'/images/ContactUs-bro.svg'}
                alt={i18n.t('PANEL_PAGE.PUSH_PIN_BUTTON_KEY')}
              />
            }
            footer={[
              {
                name: i18n.t('PANEL_PAGE.OPEN_CALL_KEY'),
                icon: <ArrowRightAltIcon />,
                onClick: () =>
                  window.open(
                    'https://portal.skyone.cloud/',
                    '_blank',
                    'noopener'
                  ),
              },
            ]}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

const mapStateToProps = ({ authenticate: { data } }: ApplicationState) => ({
  operator_uuid: data?.operator_uuid!,
});

export default connect(mapStateToProps, null)(AdministrationPanel);
